export enum DeveloperFormNames {
  Hero = "hero",
  OurValues = "ourValues",
  GetInTouch = "getInTouch",
  OurApproach = "ourApproach",
  AtAGlance = "atAGlance",
  OurServices = "ourServices",
  AboutUs = "aboutUs",
}
